'use strict';

angular.module('atex.dam').controller('DamPageViewerController', ['$scope', 'SearchService', 'ContentService',
  'PrintService', '$filter', '$sce', '$stateParams', '$q', '$window', 'DamService',
  'DamNotificationService', 'UIConfigurationService','PreviousState',
function($scope, SearchService, ContentService, PrintService, $filter, $sce, $stateParams, $q, $window, DamService,
         DamNotificationService, UIConfigurationService, PreviousState) {
  var currentLineHeightThumbList = 120;

  $scope.pageData = {};
  $scope.pagePreviewUrl = undefined;
  $scope.pageHighUrl = undefined;
  $scope.pageNotFound = false;
  $scope.showSpinner = true;
  $scope.querying = true;
  $scope.entries = [];
  $scope.partition = undefined;

  $scope.limitDesc = 250;

  $scope.toggle = "col-lg-7";

  $scope.selected = [];

  $scope.queryFields = [];

  UIConfigurationService.getSearchOptions().then(function (options) {
    var pageElementLinkQueryFields = atex.onecms.ObjectUtils.getByPath(options, 'pageElementLinkQueryFields') || [];
    if (pageElementLinkQueryFields.length > 0){
      $scope.queryFields = pageElementLinkQueryFields;
    }
  });

  $scope.clearSelection = function() {
    $scope.selected.length = 0;
  };

  $scope.back = function() {
    PreviousState.goToLastState();
  };

  function getPubleventFromId(deskpeId) {
    var publevent = {};
    if (deskpeId.indexOf('desk.pe:') === 0) {
      var splits = deskpeId.split(':');
      if (splits[1]) {
        publevent.publication = splits[1];
      }
      if (splits[2]) {
        publevent.edition = splits[2];
      }
      if (splits[3]) {
        publevent.page = splits[3];
      }
      if (splits[4]) {
        publevent.section = splits[4];
      }
      if (splits[5]) {
        publevent.pubdate = splits[5];
      }
      if (splits[6]) {
        publevent.zone = splits[6];
      }
      if (splits[7]) {
        publevent.docId = splits[7];
      }
    }
    return publevent;
  }

  function loadFromLayoutServer(pageId) {
    return PrintService.getPageElements(pageId).then(function (contents) {
      var objects = atex.onecms.ObjectUtils.getByPath(contents, 'data/objects') || [];
      var promises = objects.map(function (object) {
        return ContentService.getContent({id: object});
      });

      return $q.all(promises).then(function (_objects) {
        var entries = [];
        _.each(_objects, function (_object) {
          _object._data = _object.data;
          atex.dam.AngularUtils.fixUrls(_object._data);
          atex.dam.AngularUtils.fixWidthHeight(_object, currentLineHeightThumbList);
          entries.push(_object);
        });

        $scope.entries = entries;
      });
    });
  }

  $scope.loadElements = function() {
    var deferred = $q.defer();

    UIConfigurationService.copyfit().then(function( profileConfiguration ) {
      var useSection = (typeof profileConfiguration.useSection === "undefined") ? true : profileConfiguration.useSection;

      $scope.loadElementsFromSolr( useSection ).then(function() {
        return deferred.resolve();
      });
    });

    return deferred.promise;
  };

  $scope.loadElementsFromSolr = function( useSection ) {
    var entries = [];
    return DamService.getSolrServerInfo().then(function(solrInfo) {
      var queryElemsInfo = {
        variant : "list",
        core: solrInfo.solrCore,
        fl : "id,headline,description,body"
      };
      queryElemsInfo['q'] = "+atex_desk_objectType:(article image video audio graphic collection)";
      queryElemsInfo['q'] = queryElemsInfo['q'] + "+_query_:\"{!parent%20which='contentType_atex_desk_s:parentDocument'}(";
      if ($scope.publevent.publication && ($scope.queryFields.length === 0 || $scope.queryFields.includes("publication_atex_desk_ss"))) {
        queryElemsInfo['q'] = queryElemsInfo['q'] + "+publication_atex_desk_ss:(\\\"" + $scope.publevent.publication + "\\\")";
      }
      if ($scope.publevent.pubdate && ($scope.queryFields.length === 0 || $scope.queryFields.includes("pubdate_atex_desk_dts"))) {
        var pubdate = atex.dam.AngularUtils.toUTCDate($scope.publevent.pubdate);
        queryElemsInfo['q'] = queryElemsInfo['q'] + "+pubdate_atex_desk_dts:(\\\"" + pubdate + "\\\")";
      }
      if ($scope.publevent.edition && ($scope.queryFields.length === 0 || $scope.queryFields.includes("edition_atex_desk_ss"))) {
        queryElemsInfo['q'] = queryElemsInfo['q'] + "+edition_atex_desk_ss:(\\\"" + $scope.publevent.edition + "\\\")";
      }
      if ($scope.publevent.zone && ($scope.queryFields.length === 0 || $scope.queryFields.includes("zone_atex_desk_ss"))) {
        queryElemsInfo['q'] = queryElemsInfo['q'] + "+zone_atex_desk_ss:(\\\"" + $scope.publevent.zone + "\\\")";
      }

      if ( useSection && !_.isEmpty($scope.publevent.section && ($scope.queryFields.length === 0 || $scope.queryFields.includes("section_atex_desk_ss"))) ) {
        queryElemsInfo['q'] = queryElemsInfo['q'] + "+section_atex_desk_ss:(\\\"" + $scope.publevent.section + "\\\")";
      }
      if (_.isEmpty( $scope.publevent.docId )) {
        if ($scope.publevent.page && ($scope.queryFields.length === 0 || $scope.queryFields.includes("page_atex_desk_ss"))) {
          queryElemsInfo['q'] = queryElemsInfo['q'] + "+page_atex_desk_ss:(" + $scope.publevent.page + ")";
        }
      } else {
          if ($scope.queryFields.length === 0 || $scope.queryFields.includes("doc_id_atex_desk_ss")){
            queryElemsInfo['q'] = queryElemsInfo['q'] + "+doc_id_atex_desk_ss:(" + $scope.publevent.docId + ")";
          }
          if ($scope.publevent.page && ($scope.queryFields.length === 0 || $scope.queryFields.includes("page_atex_desk_ss"))) {
            queryElemsInfo['q'] = queryElemsInfo['q'] + "+page_atex_desk_ss:(" + $scope.publevent.page + " OR \\\"\\\")";
          }
      }

       queryElemsInfo['q'] = queryElemsInfo['q'] + ")\"";

      return SearchService.search(queryElemsInfo);
    }).then(function(response) {
      if (response.data.response.numFound <= 0) {
        return;
      }
      response.data.response.docs.forEach(function(document) {
        atex.dam.AngularUtils.fixUrls(document._data);
        atex.dam.AngularUtils.fixWidthHeight(document, currentLineHeightThumbList);
        // Check width and depth
        if (document._data.aspects.contentData.data.width !== undefined && document._data.aspects.contentData.data.width !== "0" &&
            document._data.aspects.contentData.data.height !== undefined && document._data.aspects.contentData.data.height !== "0") {
          var width = document._data.aspects.contentData.data.width * 1;
          var height = document._data.aspects.contentData.data.height * 1;
        }

        entries.push(document);
      });

      $scope.entries = entries;
    }).then(null, function(error) {
      console.log('ERROR: Getting Elements:', error);
      var message = "Error getting page elements";
      if (error && error.cause) {
        message = error.cause;
      }
      DamNotificationService.addNotification(atex.dam.Notification({ type: 'error', message: message }), true);
    });
  };

  function setPageProperties(response) {
    atex.dam.AngularUtils.fixUrls(response.data);
    $scope.pageData = response.data;
    $scope.pagePreviewUrl = response.data.aspects.contentData.data.thumbUrl;
    $scope.pageHighUrl = response.data.aspects.contentData.data.pdfUrl;
    $scope.showSpinner = false;
    $scope.querying = false;

    var publevents = atex.onecms.ObjectUtils.getByPath(response.data, 'aspects/atex.dam.standard.Publevents/data/publevents');

    if (publevents && publevents.length > 0) {
      $scope.publevent.outOfDate = publevents[0].outOfDate;
      $scope.publevent.nonPlan = publevents[0].nonPlan;
    }
  }

  $scope.loadPage = function() {
    $scope.querying = true;
    DamService.getSolrServerInfo()
    .then(function(solrInfo) {
      var transferInfo = {};
      transferInfo['core'] = solrInfo.solrCore;
      transferInfo['q'] = "+atex_desk_objectType:(page)";
      transferInfo['q'] += "+_query_:\"{!parent%20which='contentType_atex_desk_s:parentDocument'}(";
      if ($scope.publevent.edition) {
        transferInfo['q'] += "+edition_atex_desk_ss:(\\\"" + $scope.publevent.edition + "\\\")";
      }
      if ($scope.publevent.page) {
        transferInfo['q'] += "+page_atex_desk_ss:(" + $scope.publevent.page + ")";
      }
      if (!_.isEmpty( $scope.publevent.docId )) {
        transferInfo['q'] += "+doc_id_atex_desk_ss:(" + $scope.publevent.docId + ")";
      }
      if ($scope.publevent.pubdate) {
        var pubdate = atex.dam.AngularUtils.toUTCDate($scope.publevent.pubdate);
        transferInfo['q'] += "+pubdate_atex_desk_dts:(\\\"" + pubdate + "\\\")";
      }
      if ($scope.publevent.publication) {
        transferInfo['q'] += "+publication_atex_desk_ss:(\\\"" + $scope.publevent.publication + "\\\")";
      }
      if ($scope.publevent.zone) {
        transferInfo['q'] += "+zone_atex_desk_ss:(\\\"" + $scope.publevent.zone + "\\\")";
      }
      if ($scope.publevent.section) {
        transferInfo['q'] += "+section_atex_desk_ss:(\\\"" + $scope.publevent.section + "\\\")";
      }
      transferInfo['q'] += ")\"";
      return SearchService.search(transferInfo);
    }).then(function(response) {
      var solrDocs = response.data.response.docs || [];
      if (response.data.response.numFound <= 0 || solrDocs.length <= 0) {
        $scope.showSpinner = false;
        $scope.querying = false;
        $scope.pageNotFound = true;
        console.log('ERROR DamPageViewerController: Page Not Found:');
        return;
      }

      var p;
      if (solrDocs.length > 1) {
        var promises = [];
        // since we expect only some pages, we can get all the content and filter it
        solrDocs.forEach(function (doc) {
          promises.push(ContentService.getContent({id: doc.id}));
        });
        p = $q.allSettled(promises).then(function (results) {
          var docs = atex.onecms.AngularUtils.splitSettled(results).fulfilled;
          var logicals = [];
          var physicals = [];
          var samePartition = [];
          docs.forEach(function(doc) {
            var pageId = atex.onecms.ObjectUtils.getByPath(doc, 'data/aspects/atex.print.Page/data/pageId');
            if (typeof pageId !== 'undefined' && pageId.match(/_PH$/)) {
              physicals.push(doc);
            } else {
              logicals.push(doc);
              if ($scope.partition) {
                var partition = atex.dam.AngularUtils.getContentPartition(doc);
                if (partition === $scope.partition) {
                  samePartition.push(doc);
                }
              }
            }
          });
          // PMC-3066: if we found more results we will prioritize the ones with the same partition
          // and if none match we will prioritize the logical pages leaving the physical pages as the last option
          if (samePartition.length > 0) {
            return _.first(samePartition).id;
          } else if (logicals.length > 0) {
            return _.first(logicals).id;
          } else {
            return _.first(physicals).id;
          }
        });
      } else {
        // we only have one result
        p = $q.when(solrDocs[0].id);
      }
      return p.then(function(id) {
        $scope.pageId = id;
        return {
          id : $scope.pageId,
          variant : "preview"
        };
      }).then(function(getTransferInfo) {
        return ContentService.getContent(getTransferInfo).then(function (response) {
          var pageId = atex.onecms.ObjectUtils.getByPath(response, 'data/aspects/atex.print.Page/data/pageId');
          if (typeof pageId !== 'undefined' && pageId.match(/_PH$/)) {
            loadFromLayoutServer(pageId).then(function () {
              setPageProperties(response);
            });
          } else {
            $scope.loadElements().then(function () {
              setPageProperties(response);
            });
          }
        });
      });
    }).then(null, function(error) {
      $scope.showSpinner = false;
      $scope.querying = false;
      var message = "Error getting content";
      if (error && error.cause) {
        message = error.cause;
      }
      DamNotificationService.addNotification(atex.dam.Notification({ type: 'error', message: message }), true);
      console.log('ERROR DamPageViewerController: Getting content:', error);
    });
  };

  if ($scope.publevent) {
    $scope.loadPage();
  }

  $scope.$on("dam:updatedItem", function(event, data) {
    if ( data && data.id && $scope.pageData && $scope.pageData.id && data.id === $scope.pageData.id ) {
      if ($scope.publevent) {
        $scope.loadPage();
      }
    }
  });

  $scope.refresh = function() {
    if ($scope.publevent) {
      $scope.loadPage();
    }
  };

  $scope.to_trusted = function(html_code, limit) {
    if (html_code !== undefined) {
      if (limit > 0) {
        html_code = $filter('limitHtml')(html_code, limit);
      }

    }
    return $sce.trustAsHtml(html_code);
  };

  if (!$scope.partition && $stateParams.partition) {
    $scope.partition = $stateParams.partition;
  }

  if (!$scope.publevent && $stateParams.id) {
    if ($stateParams.id.indexOf('desk.pe:') === 0) {
      // It's a publevent id
      $scope.publevent = getPubleventFromId($stateParams.id);
      $scope.loadPage();
    } else {
      // Should be a pageId
      var getTransferInfo = {
        id : $stateParams.id
      };
      ContentService.getContent(getTransferInfo).then(function(response) {
        if (response.data.aspects.contentData.data.objectType==="page") {
          // In case we have an input id representing a page:
          $scope.pageId = response.data.id;
          atex.dam.AngularUtils.fixUrls(response.data);
          $scope.pageData = response.data;
          $scope.pagePreviewUrl = response.data.aspects.contentData.data.thumbUrl;
          $scope.pageHighUrl = response.data.aspects.contentData.data.pdfUrl;
          if (response.data.aspects['atex.dam.standard.Publevents'] && response.data.aspects['atex.dam.standard.Publevents'].data.publevents.length>0) {
            $scope.publevent = response.data.aspects['atex.dam.standard.Publevents'].data.publevents[0];
          }
          var pageId = atex.onecms.ObjectUtils.getByPath(response, 'data/aspects/atex.print.Page/data/pageId');
          if (typeof pageId !== 'undefined' && pageId.match(/_PH$/)) {
            loadFromLayoutServer(pageId).then(function () {
              $scope.showSpinner = false;
              $scope.querying = false;
            });
          } else {
            $scope.loadElements().then(function () {
              $scope.showSpinner = false;
              $scope.querying = false;
            });
          }
        } else {
          var message = "Unexpected type " + response.data.aspects.contentData.data.objectType;
          DamNotificationService.addNotification(atex.dam.Notification({ type: 'error', message: message }), true);
          $scope.showSpinner = false;
          $scope.querying = false;
        }
      }).then(null, function(error) {
        var message = "Error getting content";
        if (error && error.cause) {
          message = error.cause;
        }
        DamNotificationService.addNotification(atex.dam.Notification({ type: 'error', message: message }), true);
        $scope.showSpinner = false;
        $scope.querying = false;
      });
    }
  }
} ]);
